<script setup lang="ts">
import {
  tpgIconExpandLess,
  tpgIconExpandMore,
  tpgIconNoVisibility,
  tpgIconVisibility,
} from '@tpg/grammar-web-icons';
import { computed, ref, toRefs } from 'vue';

import {
  GrammarBadge,
  GrammarCard,
  GrammarDivider,
  GrammarQuaternaryButton,
} from '@nora-monorepo/grammar-ui';

interface MenuGroupProps {
  title: string;
  toggleVisibility?: () => void;
  visible?: boolean;
  initiallyExpanded?: boolean;
  badgeAmount?: number;
}

const props = withDefaults(defineProps<MenuGroupProps>(), {
  initiallyExpanded: true,
  badgeAmount: 0,
});

const { toggleVisibility } = props;

const { visible } = toRefs(props);
const expanded = ref(props.initiallyExpanded);

function toggleMenuGroupExpanded() {
  expanded.value = !expanded.value;
}

const badgeTitle = computed(() => {
  if (props.badgeAmount && props.badgeAmount > 0) {
    return `${props.title} (${props.badgeAmount})`;
  }

  return props.title;
});
</script>

<template>
  <GrammarCard
    read-only
  >
    <template #header-leading-buttons>
      <div class="min-w-0 pl-1">
        <GrammarBadge :label="badgeTitle" />
      </div>
    </template>
    <template #header-trailing-buttons>
      <div class="flex pr-1 pt-1">
        <template v-if="toggleVisibility">
          <GrammarDivider
            class="py-1 box-border"
            orientation="vertical"
          />
          <GrammarQuaternaryButton
            :icon-template="visible ? tpgIconVisibility : tpgIconNoVisibility"
            @click="toggleVisibility"
          />
        </template>
        <GrammarDivider
          class="py-1 box-border"
          orientation="vertical"
        />
        <GrammarQuaternaryButton
          :icon-template="expanded ? tpgIconExpandLess : tpgIconExpandMore"
          @click="toggleMenuGroupExpanded"
        />
      </div>
    </template>
    <template
      v-if="expanded"
      #card-row-1
    >
      <div class="min-h-0 p-1">
        <slot />
      </div>
    </template>
  </GrammarCard>
</template>
